module.exports = __webpack_public_path__ + "img/preview-lg.d1dda955.png";